<form [formGroup]="glnForm" novalidate>
    <ng-container *ngIf="!useFCDesignSystemComponents">
        <div class="fc-gln-old-components-wrapper">
            <div class="fc-gln-form-checkbox-wrapper">
                <div>
                    <fcp-checkbox [checked]="useFcGln" (change)="updateUseFcGln($event)" data-e2e-hook="use-fc-gln">
                        <span>{{ 'CREATE_STORE.PROVIDE_WITH_GLN' | translate }}</span>
                    </fcp-checkbox>

                    <p *ngIf="fcGln" class="fc-gln-text">{{ 'MANAGE_STORE.YOUR_FC_GLN' | translate }}: {{ fcGln }}</p>
                </div>
            </div>

            <div class="fc-gln-form-wrapper">
                <!-- Shipping GLN -->
                <div class="fc-gln-form-input-wrapper">
                    <fcp-form-field [isInvalid]="isFieldInvalid(glnForm, 'gln')" [width]="'fluid'">
                        <label
                            fcpFieldLabel
                            [ngClass]="{ 'fc-gln-form-label-disabled': useFcGln, 'fc-gln-form-label': !useFcGln }"
                        >
                            {{ 'DELIVERY_GLN' | translate }}
                            <span
                                class="fc-gln-form-info-icon"
                                [matTooltip]="'GLN_FORM.DELIVERY_GLN_TOOLTIP' | translate"
                                matTooltipClass="large-tooltip-text"
                            >
                                <fcp-icon-svg
                                    [icon]="iconMapName.circleExclamation"
                                    [color]="fcpIconSVGColors.NeutralDark"
                                    [size]="fcpIconSVGSizes.Small"
                                ></fcp-icon-svg>
                            </span>
                        </label>
                        <input fcpInput [disabled]="!useFcGln" formControlName="gln" maxlength="13" />
                        <span fcpFieldError>
                            {{
                                (glnForm.get('gln').errors?.existingGln
                                    ? 'MANAGE_CLARA.CREATE_BRANCH.GLN.VALIDATION.DELIVERY_GLN_ALREADY_EXISTS'
                                    : 'MANAGE_CLARA.CREATE_BRANCH.GLN.VALIDATION.DELIVERY_GLN'
                                ) | translate
                            }}
                        </span>
                    </fcp-form-field>
                </div>

                <!-- Buyer GLN -->
                <div class="fc-gln-form-input-wrapper">
                    <fcp-form-field [isInvalid]="isFieldInvalid(glnForm, 'buyerGln')" [width]="'fluid'">
                        <label
                            fcpFieldLabel
                            [ngClass]="{ 'fc-gln-form-label-disabled': useFcGln, 'fc-gln-form-label': !useFcGln }"
                        >
                            {{ 'MANAGE_CLARA.CREATE_BRANCH.BUYER_GLN' | translate }}
                            <span class="fc-gln-form-optional">(Optional)</span>
                            <span
                                class="fc-gln-form-info-icon"
                                [matTooltip]="'GLN_FORM.BUYER_GLN_TOOLTIP' | translate"
                                matTooltipClass="large-tooltip-text"
                            >
                                <fcp-icon-svg
                                    [icon]="iconMapName.circleExclamation"
                                    [color]="fcpIconSVGColors.NeutralDark"
                                    [size]="fcpIconSVGSizes.Small"
                                ></fcp-icon-svg>
                            </span>
                        </label>
                        <input fcpInput [disabled]="!useFcGln" formControlName="buyerGln" maxlength="13" />
                        <span fcpFieldError>
                            {{ 'MANAGE_CLARA.CREATE_BRANCH.GLN.VALIDATION.DELIVERY_GLN' | translate }}
                        </span>
                    </fcp-form-field>
                </div>

                <!-- Billing GLN -->
                <div class="fc-gln-form-input-wrapper">
                    <fcp-form-field [isInvalid]="isFieldInvalid(glnForm, 'billingGln')" [width]="'fluid'">
                        <label
                            fcpFieldLabel
                            [ngClass]="{ 'fc-gln-form-label-disabled': useFcGln, 'fc-gln-form-label': !useFcGln }"
                        >
                            {{ 'MANAGE_CLARA.CREATE_BRANCH.BILLING_GLN' | translate }}
                            <span class="fc-gln-form-optional">(Optional)</span>
                            <span
                                class="fc-gln-form-info-icon"
                                [matTooltip]="'GLN_FORM.BILLING_GLN_TOOLTIP' | translate"
                                matTooltipClass="large-tooltip-text"
                            >
                                <fcp-icon-svg
                                    [icon]="iconMapName.circleExclamation"
                                    [color]="fcpIconSVGColors.NeutralDark"
                                    [size]="fcpIconSVGSizes.Small"
                                ></fcp-icon-svg>
                            </span>
                        </label>
                        <input fcpInput [disabled]="!useFcGln" formControlName="billingGln" maxlength="13" />
                        <span fcpFieldError>
                            {{ 'MANAGE_CLARA.CREATE_BRANCH.GLN.VALIDATION.DELIVERY_GLN' | translate }}
                        </span>
                    </fcp-form-field>
                </div>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="useFCDesignSystemComponents">
        <div class="fc-gln-form-wrapper fc-gln-form-design-system-components-wrapper">
            <div>
                <fcp-checkbox [checked]="useFcGln" (change)="updateUseFcGln($event)" data-e2e-hook="use-fc-gln">
                    <span>{{ 'CREATE_STORE.PROVIDE_WITH_GLN' | translate }}</span>
                </fcp-checkbox>

                <div>
                    <label for="gln">
                        {{ 'DELIVERY_GLN' | translate }}

                        <div class="fc-gln-form-field">
                            <fcp-form-field [isInvalid]="isFieldInvalid(glnForm, 'gln')" [width]="'fluid'">
                                <input
                                    id="gln"
                                    fcpInput
                                    formControlName="gln"
                                    maxlength="13"
                                    [placeholder]="'DELIVERY_GLN' | translate"
                                    data-e2e-hook="gln"
                                />
                                <span fcpFieldError>{{
                                    (glnForm.get('gln').errors?.existingGln
                                        ? 'MANAGE_CLARA.CREATE_BRANCH.GLN.VALIDATION.DELIVERY_GLN_ALREADY_EXISTS'
                                        : 'MANAGE_CLARA.CREATE_BRANCH.GLN.VALIDATION.DELIVERY_GLN'
                                    ) | translate
                                }}</span>
                            </fcp-form-field>
                        </div>
                    </label>

                    <div class="fc-gln-form-panel-form-group">
                        <label for="buyerGln">
                            {{ 'MANAGE_CLARA.CREATE_BRANCH.BUYER_GLN' | translate }}
                            <span class="fc-gln-form-optional">
                                {{ 'MANAGE_CLARA.CREATE_BRANCH.OPTIONAL_LABEL' | translate }}
                            </span>

                            <fcp-form-field [isInvalid]="isFieldInvalid(glnForm, 'buyerGln')" [width]="'fluid'">
                                <input
                                    id="buyerGln"
                                    fcpInput
                                    formControlName="buyerGln"
                                    maxlength="13"
                                    [placeholder]="'MANAGE_CLARA.CREATE_BRANCH.BUYER_GLN' | translate"
                                    data-e2e-hook="buyer-gln"
                                />
                                <span fcpFieldError>{{
                                    'MANAGE_CLARA.CREATE_BRANCH.GLN.VALIDATION.DELIVERY_GLN' | translate
                                }}</span>
                            </fcp-form-field>
                        </label>

                        <label for="billingGln">
                            {{ 'MANAGE_CLARA.CREATE_BRANCH.BILLING_GLN' | translate }}
                            <span class="fc-gln-form-optional">
                                {{ 'MANAGE_CLARA.CREATE_BRANCH.OPTIONAL_LABEL' | translate }}
                            </span>

                            <fcp-form-field [isInvalid]="isFieldInvalid(glnForm, 'billingGln')" [width]="'fluid'">
                                <input
                                    id="billingGln"
                                    fcpInput
                                    formControlName="billingGln"
                                    maxlength="13"
                                    [placeholder]="'MANAGE_CLARA.CREATE_BRANCH.BILLING_GLN' | translate"
                                    data-e2e-hook="billing-gln"
                                />
                                <span fcpFieldError>{{
                                    'MANAGE_CLARA.CREATE_BRANCH.GLN.VALIDATION.DELIVERY_GLN' | translate
                                }}</span>
                            </fcp-form-field>
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</form>
